import { downApi } from 'yxt-biz-pc/packages/api';

export const getDownloadStaticFile = (filename) => {
  return downApi.get(`nfs/talent?fileName=${filename}`);
};
